import { Mic, PenLine, Crown, Zap } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import { useAuth } from "@/context/AuthContext";
import styles from "./QuickAddChooser.module.css";

interface QuickAddChooserProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectVoice: () => void;
  onSelectManual: () => void;
}

export function QuickAddChooser({ isOpen, onClose, onSelectVoice, onSelectManual }: QuickAddChooserProps) {
  const { user } = useAuth();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Novo lançamento">
      <div className={styles.grid}>
        <button type="button" className={styles.optionVoice} onClick={onSelectVoice}>
          <span className={styles.optionGlow} aria-hidden />
          {user?.isPremium ? (
            <span className={styles.premiumBadge}>
              <Zap size={11} strokeWidth={2.5} />
              Mais rápido
            </span>
          ) : (
            <span className={styles.premiumBadge}>
              <Crown size={11} strokeWidth={2.5} />
              Premium
            </span>
          )}
          <span className={styles.optionIconVoice}>
            <Mic size={24} strokeWidth={2.2} />
          </span>
          <span className={styles.optionTextVoice}>
            <span className={styles.optionTitleVoice}>Falar o ganho/gasto</span>
            <span className={styles.optionHintVoice}>Fale e a IA preenche tudo pra você</span>
          </span>
        </button>

        <button type="button" className={styles.optionManual} onClick={onSelectManual}>
          <span className={styles.optionIconManual}>
            <PenLine size={20} strokeWidth={2.2} />
          </span>
          <span className={styles.optionText}>
            <span className={styles.optionTitle}>Anotar manualmente</span>
            <span className={styles.optionHint}>O esforço de digitar é o que fica na memória</span>
          </span>
        </button>
      </div>
    </Modal>
  );
}
